import React from "react";
import DialogSalir from "../../components/DialogSalir";
import Resultado from "../TriviasResultado/Render";

import "./styles.css";

const Render = (props, context) => {
  if (!props.trivia) return <div />;
  return (
    <div>
      {props.points === null ? (
        <section className="desafios consigna backgroundImage preguntas pbxl verticalCenterFlex">
          <div className="container pRel borderBox phlMO">

            <p className="nombre avenirBK white">
              Trivia: <span className="avenirR">{props.trivia.name}</span>
            </p>
            <p className="preguntaN white upperCase">
              Pregunta{" "}
              <span className="avenirBK white">{props.currentQuestion + 1}</span>/
              {props.trivia.questions.length}
            </p>
            <p className="cifra man avenirBK white upperCase alignCenter mtl mbl">
              {props.trivia.points} <span className="avenirL">pts</span>
            </p>

            <h2 className="avenirBK white bgNone alignCenter borderBottomNone">
              {props.trivia.questions[props.currentQuestion].question}
            </h2>

            <ul className="preguntasUl unstyled clearfix mha">
              {props.trivia.questions[props.currentQuestion].answers.map(
                answer => {
                  let selected = "";
                  let correct = "";
                  if (answer.id === props.selectedAnswer) {
                    selected = "selected";
                    if (props.answered) {
                      if (answer.id === props.selectedAnswer && true === answer.valid) {
                        correct = "correct";
                      } else {
                        correct = "incorrect";
                      }                  
                    }
                  }
                  return (
                    <li
                      key={answer.id}
                      className={`borderBox hoverGrow mhaMO alignCenter ${selected} ${correct}`}
                      onClick={props.selectAnswer.bind(null, answer.id)}
                    >
                      <span className="fullWidth">{answer.answer}</span>
                    </li>
                  );
                }
              )}
            </ul>

            <ul className="btnUl unstyled">
              {!props.answered &&
                <li>
                  <a className="btn mha btnGold" onClick={props.checkAnswer}>
                    Verificar
                  </a>
                </li>
              }
              {props.selectedAnswer && props.answered &&
                <li>
                  <a className="btn mha btnGold" onClick={props.answer}>
                    Siguiente
                  </a>
                </li>
              }
              <li>
                <a className="btn btnVolver mha white" onClick={props.onBack}>
                  &lt; Volver
                </a>
              </li>
            </ul>
          </div>
          {props.showDialogoSalir && <DialogSalir {...props} />}
        </section>
      ) : (
        <Resultado trivia={props.trivia} points={props.points} correctAnswers={props.correctAnswers} totalQuestions={props.totalQuestions} />
      )}
    </div>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/TriviasPreguntas/Render.js